module.exports = __webpack_public_path__ + "static/media/1.27541aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/17065/1.jpg
// module id = 593
// module chunks = 0